import { observer } from 'mobx-react-lite'
import { type SearchableUser } from '@/features/iam/users/SearchableUser'
import { type UserManagementViewModel } from '@/features/user-management/UserManagement/UserManagementViewModel'
import {
  UserManagementTableRow,
  UserRowActions,
} from '@/features/user-management/components/UserManagementTableRow'

export interface UserManagementTableRowContainerProps {
  vm: UserManagementViewModel
  user: SearchableUser
}

export const UserManagementTableRowContainer = observer(
  function UserManagementTableRowContainer({
    vm,
    user,
  }: UserManagementTableRowContainerProps) {
    return (
      <UserManagementTableRow
        publicId={user.publicId}
        displayName={user.displayName}
        online={user.online}
        email={user.email}
        userDataType={user.userDataType}
        isWorkspaceCustomer={user.isWorkspaceCustomer}
        lastSeen={user.lastSeen}
        dateCreated={user.dateCreated}
        isSelected={vm.isSelected(user.publicId)}
        onToggleSelected={(checked) => vm.toggleUser(checked, user.publicId)}
        actions={<UserRowActionsContainer vm={vm} user={user} />}
      />
    )
  },
)

export interface UserRowActionsContainerProps {
  vm: UserManagementViewModel
  user: SearchableUser
}

export const UserRowActionsContainer = observer(
  function UserRowActionsContainer({ vm, user }: UserRowActionsContainerProps) {
    return (
      <UserRowActions
        publicId={user.publicId}
        canManageGlobalCapacity={vm.canManageGlobalCapacity}
        isWorkspaceSelected={vm.isWorkspaceSelected}
        isShowingInactiveUsers={vm.userSearch.userInactiveFilter.value}
        onInvite={() => vm.inviteUser(user)}
        onManageCapacity={() => vm.manageUserCapacity(user)}
        onRestore={() => vm.restoreUser(user)}
        onEditRole={() => vm.editUserRole(user)}
        onManageSkills={() => vm.manageUserSkills(user)}
        onRemove={() => vm.removeUser(user)}
      />
    )
  },
)
